import script from "./AuthoringTool.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthoringTool.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__